<template>
  <div id="app" data-app>
    <router-view />
    <!-- global notification -->
    <v-snackbar
      v-model="notificationVisible"
      class="notification"
      top
      :timeout="notificationInterval"
      color="rgba(47, 47, 47, 0.7)"
      width="150"
    >
      {{ $t(`notification.${notificationText}`) }}
    </v-snackbar>
    <!-- v-if="isProcessView && processViewMounted" -->
    <drop v-if="isProcessView && processViewMounted" class="drop-zone" @drop="handleDrop">
    </drop>
    <drag v-if="isProcessView && processViewMounted">
      <FeedbackButton
        :open="feedbackDialogVisible"
        :top="fbTop" 
        :bottom="!fbTop" 
        :right="!fbLeft" 
        :left="fbLeft" 
        @closed="onFeedbackClosed">
      </FeedbackButton>
    </drag>
  </div>
</template>

<script>
import FeedbackButton from "@/components/process/FeedbackButton.vue"

// function touchHandler(event) {
//   const touch = event.changedTouches[0]

//   const simulatedEvent = document.createEvent("MouseEvent")

//   simulatedEvent.initMouseEvent({
//       touchstart: "mousedown",
//       touchmove: "mousemove",
//       touchend: "mouseup"
//   }[event.type], true, true, window, 1,
//       touch.screenX, touch.screenY,
//       touch.clientX, touch.clientY, false,
//       false, false, false, 0, null)

//   touch.target.dispatchEvent(simulatedEvent)
//   event.preventDefault()
// }

// function init() {
//   document.addEventListener("touchstart", touchHandler, true);
//   document.addEventListener("touchmove", touchHandler, true);
//   document.addEventListener("touchend", touchHandler, true);
//   document.addEventListener("touchcancel", touchHandler, true);
// }
import axios from 'axios';

export default {
  data() {
    return {
      isMobile: window.innerWidth <=700,
      timer: null,
      gid: null,
      bpmTimer: null,
      notificationTimer: null,
      processViewMounted: false,
      fbTop: false,
      fbLeft: false,
    }
  },
  components: {
    FeedbackButton,
  },
  methods: {
    geolocationWatch() {
      console.log('Updating geolocation')
      if (this.$store.getters.isAuthenticated) {
        if (navigator.geolocation) {
          // NOTE: Make sure you clear watch for every instance
          this.gid = navigator.geolocation.watchPosition(this.geolocationTrackPosition, this.geolocationErrorHander);
        } else {
          console.log('Geolocation is not supported by this browser!')
        }
      } else {
        console.log("Not authenticated!")
      }
    },
    geolocationTrackPosition(position) {
      console.log (position.coords);
      position.coords.timestamp = position.timestamp / 1000;
      this.$store.dispatch('updateGeolocation', position.coords)
      .then(response => {
        console.log('Updating geolocation is successful!', response)
      })
      .catch(error => {
        console.log('Updating geolocation failed!', error)
      })

      if (this.gid) {
        navigator.geolocation.clearWatch(this.gid)
      }
    },
    geolocationErrorHander(error) {
      console.log('geolocation_error', error)
      if (this.gid) {
        navigator.geolocation.clearWatch(this.gid)
      }
    },
    async moveTo(route_name) {
      await this.$router.push({ name: route_name })
      .catch(error => {
        console.log("Routing exception caught:", error)
      })
      this.processViewMounted = true
    },
    updateTaskDefinitionKey() {
      const pid = this.$store.getters.getCurrentPID
      const previousTDK = this.$store.getters.getCurrentTDK

      this.$store.dispatch('retrieveTaskDefinitionKey', pid)
      // eslint-disable-next-line no-unused-vars
      .then(response => {
        const currentTDK = this.$store.getters.getCurrentTDK
        const currentTask = this.$store.getters.getCurrentTask
        console.log("Updating taskDefinitionKey")

        if (currentTDK === null) {
          console.log("No taskDefinitionKey")
          if (!this.showNotification) {
            this.showNotification = true
          }
        } else {
          if (previousTDK !== currentTDK) {
            console.log("TDK changed from %s to %s", previousTDK, currentTDK)

            switch (currentTask.taskType) {
              case 'userTask':
                {
                  const link = this.$router.resolve({ name: currentTDK })

                  if (link && link.href !== '/') { // route exists
                    console.log("Current route", this.$router.currentRoute.name)
                    if (this.$router.currentRoute.name !== currentTDK) {
                      this.moveTo(currentTDK)
                    } else {
                      console.log("Already routed to", currentTDK)
                    }
                  } else { // route does not exist, show notification to user
                    if (!this.notificationVisible) {
                      if (this.notificationTimer) {
                        clearInterval(this.notificationTimer)
                      }
                      this.$store.dispatch('showNotification', {
                        text:'noViewAvailable',
                        interval: 4000
                      })
                    }
                  }
                }
                break
              
              case 'manualTask':
                this.moveTo('manualtask')
                break
              default:
                this.moveTo('backgroundtask')
                break
            }
          }
        }
      })
      .catch(error => {
        console.log("PID: %s", pid, error)
      })
    },
    hideNotification() {
      this.$store.dispatch('hideNotification', false)
      if (this.notificationTimer) {
        clearInterval(this.notificationTimer)
      }
    },
    onFeedbackClosed(success) {
      this.$store.dispatch('showNotification', {
        text: success ? 'feedbackSent' : 'feedbackFailed',
        interval: 4000})
    },
    handleDrop() {
      const e = window.event
      const screenWidth = document.documentElement.clientWidth
      const screenHeight = document.documentElement.clientHeight

      this.fbTop = e.clientY < screenHeight / 2
      this.fbLeft = e.clientX < screenWidth / 2

      console.log("%s %s %s %s", e.clientX, e.clientY, screenWidth, screenHeight)

      console.log("Dropped position %s %s", (e.clientY < screenHeight / 2) ? "top" : "bottom", (e.clientX < screenWidth / 2) ? "left" : "right")
    }
  },
  computed: {
    notificationVisible: function () {
      return this.$store.getters.notificationVisible
    },
    notificationText: function () {
      return this.$store.getters.notificationText
    },
    notificationInterval: function () {
      return this.$store.getters.notificationInterval
    },
    isProcessView: function () {
      console.log("isProcessView", this.$store.getters.getCurrentPID !== null)
      return this.$store.getters.getCurrentPID !== null
    },
    feedbackDialogVisible: function () {
      return this.$store.getters.feedbackDialogVisible
    }
  },
  watch: {
    notificationVisible: function () {
      if (this.notificationVisible === true) {
        this.notificationTimer = setInterval(this.hideNotification, this.notificationInterval)
      }
    }
  },
  created() {
    this.$i18n.locale = localStorage.getItem('lang')

    addEventListener('resize', () => {
      this.isMobile = window.innerWidth <=700
    })

    const interval = parseInt(process.env.VUE_APP_GPS_UPDATE_INTERVAL)
    console.log("Scheduling geolocation update with interval of",  interval / 1000, "seconds.")
    this.timer = setInterval(this.geolocationWatch, interval);

    /**
     * this will watch over the current process's instance ID which resides in store
     */
    this.unwatch = this.$store.watch(
      (state, getters) => getters.getCurrentPID,
      // eslint-disable-next-line no-unused-vars
      (newValue, oldValue) => {
        if (newValue !== null) {
          if (this.bpmTimer) {
            clearInterval(this.bpmTimer)
          }

          this.bpmTimer = setInterval(this.updateTaskDefinitionKey, 1000)
        } else {
          this.processViewMounted = false
          if (this.bpmTimer) {
            clearInterval(this.bpmTimer)
          }

          this.$router.push({ name: 'dashboard' })
        }
      }
    )

    /* Frontend/#109 td 202009081048 when session expires the app still relies on localstorage for auth status */
    axios.interceptors.response.use(undefined, function (err) {
        return new Promise(function ( resolve, reject ) {

          if (err.response.status === 403) {
            console.log('axios intercepted a 403')
            localStorage.removeItem('isAuthenticated')
            localStorage.removeItem('userID')
            this.$router.push({ path: '/' })

            this.$store.commit('setCurrentProcess', null)
            this.$store.commit('setCars', [])
            

            return reject(err)
          }
//          throw err;
        });
      });    
  },
  beforeDestroy() {
    this.unwatch()

    if (this.gid) {
      navigator.geolocation.clearWatch(this.gid)
    }
    
    if (this.timer) {
      clearInterval(this.timer)
    }
    
    if (this.bpmTimer) {
      clearInterval(this.bpmTimer)
    }

    if (this.notificationTimer) {
      clearInterval(this.notificationTimer)
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Rubik');

#app {
  font-family: Rubik, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  text-transform: none;
}

.container .neat-container {
  padding: 0;
}

.category-label {
  font-size: 1.125rem;
  font-weight: bold;
  text-align: left;
  margin-top: 1.1875rem;
  margin-bottom: 0.625rem;
  color: black;
}

.drop-zone {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0);
  /* pointer-events: none; */
  z-index: -1;
}

.notification {
  margin-top: 6rem;
}

.desc {
  font-size: 0.9375rem;
  color: #8798ad;
}

.submit-btn {
  margin-top: 2rem;
}

.v-input--radio-group--row .v-input--radio-group__input {
  justify-content: center;
}

.center {
  align-items: center;
  justify-content: center;
}

.label {
  display: flex;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.75rem;
  font-weight: bold;
  color: #b0bac9;
  padding-bottom: 0.5rem;
}

.title {
  font-size: 1.75rem;
  font-weight: 400;
  color: #2e384d;
  margin-bottom: 1px;
}

.separator {
  width: 100%;
  border-top: 1px solid #d4ddec;
  padding-bottom: 9px;
}

label {
  margin-bottom: 0 !important;
}

.chart-label {
  color: "#d2d2d2";
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
}

.h-flip {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.overlay {
  position: fixed;
  width: 100vw;
  height: calc(100vh - 48px);
  top: 48px;
  left: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.25);
  -webkit-backdrop-filter: blur(9px);
  backdrop-filter: blur(9px);
  /* pointer-events: none; */
  z-index: 4;
}

.metric-card {
  /* height: 10.25rem; */
  padding: 1rem;
  border: 1px solid rgba(46, 91, 255, 0.0784);
}

.input-control {
  background-color: rgba(224, 231, 255, 0.2);
}

.page-icon {
  margin-top: 2.5rem;
  text-shadow: 0px 0px 3px #2e384d;
}

.desc {
  margin-top: 1.375rem;
  margin-bottom: 2.1875rem!important;
  font-size: 0.875rem;
  font-weight: lighter;
  color: #2e384d;
}

.v-text-field--outlined fieldset {
  border-color: #e0e7ff !important;
}

.vue-treeselect__control {
  border: 1px solid #e0e7ff;
  height: 2.5rem;
}

.append-unit .v-input__append-inner {
  margin-top: 0.328rem !important;
}

.append-unit .v-input__slot {
  padding: 0 0.328rem 0 0.75rem !important;
}

.v-data-table__wrapper {
  text-align: left;
  font-size: 14px;
  color: black;
}

/* 
  TODO: find a better approach
*/
.v-data-table__wrapper .table-head {
  color: black !important;
  font-size: 14px !important;
  font-weight: bold;
}

.page-content .v-treeview-node__root {
  padding-left: 0;
  padding-right: 0;
}

.page-content .v-treeview-node__toggle {
  width: 0;
}

.page-content .v-treeview-node__label {
  flex: unset;
  margin-left: 8px;
  font-size: 18px;
}

.page-content .v-treeview-node__level {
  width: 12px;
}

.v-snack__content {
  text-align: center !important;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}

.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}

/*
@media only screen and (max-width: 376px) {
  .page-content {
    width: 330px;
    padding: 0;
  }
}
*/
</style>
